export var StatusValues = ['requested', 'delivered', 'canceled'];
